import type { IconData } from '@stacksjs/iconify-core'

export const pin2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 19c0 8.837-7.163 16-16 16s-16-7.163-16-16S20.163 3 29 3s16 7.163 16 16\"/><path d=\"m14.55 25.878l-.36.504C8.091 34.953 1.928 43.614 3.157 44.843c1.229 1.23 9.89-4.934 18.462-11.034l.503-.358M36.07 11.929c-3.905-3.906-10.237-3.906-14.142 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pin2
